import styled from 'styled-components';
import colors from 'styles/colors';
import sizes from 'styles/sizes';
import { BrandCode } from 'types';

export const MapCruiseCardGrid = styled.ul`
	list-style: none;
	margin: 0;
	padding: 20px 0;
	display: grid;
	font-family: ${({ theme }) => theme.typography.fontFamily};
	grid-auto-rows: minmax(94px, auto);

	li {
		border-bottom: 1px solid gray;
	}

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
				grid-template-columns: repeat(auto-fit, minmax(297px, 1fr));
				color: ${colors.celebrity.grey};
			`,

			[BrandCode.RoyalCaribbean]: `
				grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
				color: ${colors.functional.softGrey};
			`,
		})[theme.brandCode]};

		@media (min-width: ${sizes.media.smallMaxWidth}px) {
			grid-template-columns: repeat(3, minmax(130px, 100%));

			li:nth-child(3n+1):nth-last-child(-n+3),
			li:nth-child(3n+1):nth-last-child(-n+3) ~ li {
				border-bottom: 0;
			}
		}

		@media (min-width: ${sizes.media.tabletPortrait}px) {
			grid-template-columns: repeat(4, minmax(130px, 100%));
			
			li:nth-child(4n+1):nth-last-child(-n+4),
			li:nth-child(4n+1):nth-last-child(-n+4) ~ li {
				border-bottom: 0;
			}
		}

		@media (min-width: ${sizes.constrains.desktop}px) {
			grid-template-columns: repeat(5, minmax(130px, 100%));

			li:nth-child(5n+1):nth-last-child(-n+5),
			li:nth-child(5n+1):nth-last-child(-n+5) ~ li {
				border-bottom: 0;
			}
		}
`;

export const MapCruiseCardGridItem = styled.li`
	padding: 15px 0;
	display: flex;
	flex-direction: column;

	&.with-border {
	}
`;

export const MapCruiseCardGridDay = styled.p`
	text-transformation: uppercase;
	font-family: ${({ theme }) => theme.typography.fontFamilySemibold};
	font-size: 10px;
	font-weight: 600;
	letter-spacing: 0.02rem;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
				line-height: 15px;
				@media (min-width: ${sizes.media.smallMaxWidth}px) {
					font-size: 12px;
					line-height: 18px;
				}
			`,
			[BrandCode.RoyalCaribbean]: `
				line-height: 12.18px;
			
				@media (min-width: ${sizes.media.tabletPortrait}px) {
					font-size: 14px;
					line-height: 17.05px;
				}
			`,
		})[theme.brandCode]}
`;

export const MapCruiseCardGridDate = styled.p`
	font-weight: 400;
	line-height: 18px;
	font-size: 12px;
	text-transform: capitalize;
	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
				margin-top: 2px;
				`,
			[BrandCode.RoyalCaribbean]: `
				@media (min-width: ${sizes.media.smallMaxWidth}px) {
					line-height: 21px;
				}
				`,
		})[theme.brandCode]}
`;

export const MapCruiseCardGridPort = styled.p`
	text-transformation: capitalize;
	font-weight: 600;
	font-size: 14px;
	line-height: 17.05px;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
					margin-top: 5px;
				`,
			[BrandCode.RoyalCaribbean]: `
					color: ${theme.palette.text.primary};

					@media (min-width: ${sizes.media.smallMaxWidth}px) {
						line-height: 24px;
					}
				`,
		})[theme.brandCode]};
`;

export const MapCruiseCardGridActivity = styled.p`
	font-size: 10px;
	font-style: italic;
	font-weight: 400;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
			line-height: 12.18px;
			margin-top: 3px;

			@media (min-width: ${sizes.media.smallMaxWidth}px) {
				font-size: 12px;
				line-height: 18px;
			}

			`,
			[BrandCode.RoyalCaribbean]: `
				@media (min-width: ${sizes.media.smallMaxWidth}px) {
					font-size: 12px;
					line-height: 14.6px;
				}
			`,
		})[theme.brandCode]}
`;

export const MapCruiseCardGridDisclaimer = styled.div`
	font-family: inherit;
	font-size: 14px;

	${({ theme }) =>
		({
			[BrandCode.Celebrity]: `
			color: ${colors.celebrity.grey};
			line-height: 21px;
			`,
			[BrandCode.RoyalCaribbean]: `
			color: ${theme.palette.text.secondary};
			line-height: 17.05px;
			`,
		})[theme.brandCode]}
`;
